const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
// Matches the backend's "DD MMM YYYY HH:mm:ss" UTC timestamp format, e.g. "07 Aug 2026 10:23:00".
const UTC_TIMESTAMP_REGEX = /^(\d{2})\s+([A-Za-z]{3})\s+(\d{4})\s+(\d{2}):(\d{2}):(\d{2})$/;

/** Parses the backend's UTC "DD MMM YYYY HH:mm:ss" timestamp and renders it in local time. */
export function formatDate(dateString: string): string {
  if (!dateString) return "";

  const match = UTC_TIMESTAMP_REGEX.exec(dateString.trim());
  if (!match) return dateString;

  const [, day, monthAbbr, year, hh, mm, ss] = match;
  const monthIndex = MONTHS.findIndex((m) => m.toLowerCase() === monthAbbr!.toLowerCase());
  if (monthIndex === -1) return dateString;

  const utcMs = Date.UTC(Number(year), monthIndex, Number(day), Number(hh), Number(mm), Number(ss));
  const local = new Date(utcMs);
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${local.getDate()} ${MONTHS[local.getMonth()]} ${local.getFullYear()} ${pad(local.getHours())}:${pad(local.getMinutes())}:${pad(local.getSeconds())}`;
}
